import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainReality } from './components/PainReality';
import { SevenDayPlan } from './components/SevenDayPlan';
import { FacebookWall } from './components/FacebookWall';
import { ValueStack } from './components/ValueStack';
import { TwoPaths } from './components/TwoPaths';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen font-sans bg-white text-body selection:bg-primary/30 selection:text-primary" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <PainReality data-id="element-3" />
      <SevenDayPlan data-id="element-4" />
      <FacebookWall data-id="element-5" />
      <ValueStack data-id="element-6" />
      <TwoPaths data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <RecentPurchaseToast data-id="element-10" />
    </div>;
}